'use strict';

let env = require('shared/scripts/env');

require('views/start.intro.inc.less');

angular.module('app')
    .component('ngIncludeViewsCommonTopNavigation', {
        template: require('views/common/top_navigation.html')
    })
    .component('ngIncludeViewsCommonTopMenu', {
        template: require('views/navigation/top-menu.html'),
        controller: function (DataEnvironmentService, $scope, $state, restrictUi, authService) {

            $scope.dataEnvironments = DataEnvironmentService.dataEnvironments;
            $scope.activeDataEnvironment = DataEnvironmentService.activeDataEnvironment;
            $scope.setDataEnvironment = DataEnvironmentService.setDataEnvironment;
            $scope.$state = $state;
            $scope.restrictUi = restrictUi;
            $scope.resetPasswordIsRelevant = function () {
                return false;
            };
            authService.authenticatedDefer.promise.then(function (profile) {
                $scope.resetPasswordIsRelevant = function () {
                    let relevant = false;
                    for (let i = 0; i < profile.identities.length; i++) {
                        if (profile.identities[i].connection === 'Username-Password-Authentication') {
                            relevant = true;
                            break;
                        }
                    }
                    return relevant;
                }
            });
        }
    })
    .component('ngIncludeViewsCommonFooter', {
        template: require('views/common/footer.html'),
        controller: function ($scope) {
            $scope.env = env;
            $scope.date = new Date();
        }
    })
    .component('ngIncludeStartOnboarding', {
        template: require('views/start.onboarding.inc.html')
    })
    .component('ngIncludeStartPricing', {
        template: require('views/start.pricing.inc.html')
    })
    .component('ngIncludeStartIntroVideo', {
        template: require('views/start.intro-video.inc.html')
    })
    .component('ngIncludeStartIntro', {
        template: require('views/start.intro.inc.html')
    })
    .component('ngIncludeStartIntroContents', {
        template: require('views/start.intro-contents.inc.html'),
        controller: function (DataEnvironmentService, $scope, $state, restrictUi, authService) {

            $scope.dataEnvironments = DataEnvironmentService.dataEnvironments;
            $scope.activeDataEnvironment = DataEnvironmentService.activeDataEnvironment;
            $scope.setDataEnvironment = DataEnvironmentService.setDataEnvironment;
            $scope.$state = $state;
            $scope.restrictUi = restrictUi;
            $scope.authService = authService;

        }
    })
    .component('ngIncludeStartUseCases', {
        template: require('views/start.use-cases.inc.html')
    })
    .component('ngIncludeStartAboutFaq', {
        template: require('views/start.about-faq.inc.html')
    })
    .component('ngIncludeStartContact', {
        template: require('views/start.contact.inc.html')
    })
;



// WEBPACK FOOTER //
// .-dna/app/scripts/app.ng-includes.js